/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
  AdsFeedControllerGetGoogleAdsPagesFeedPathParams,
} from '../types/AdsFeedControllerGetGoogleAdsPagesFeed.ts';

function getAdsFeedGetGoogleAdsPagesFeedUrl(wlDomain: AdsFeedControllerGetGoogleAdsPagesFeedPathParams['wlDomain']) {
  const res = { method: 'GET', url: `/api/ads-feed/${wlDomain}/google-ads-pages.csv` as const };
  return res;
}

/**
 * {@link /api/ads-feed/:wlDomain/google-ads-pages.csv}
 */
export async function adsFeedGetGoogleAdsPagesFeed(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesFeedPathParams['wlDomain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getAdsFeedGetGoogleAdsPagesFeedUrl(wlDomain).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
